export const getPreviewBounds = ({
  width,
  height,
  top = 0,
  left = 0,
  navbarBottom = 0,
  maxWidth = 728
}) => {
  const margin = 12;
  const minTop = Math.min(
    Math.max(top, navbarBottom) + margin,
    top + height - margin
  );
  return {
    left: left + margin,
    top: minTop,
    right: left + width - margin,
    bottom: top + height - margin,
    width: Math.min(
      maxWidth,
      Math.max(420, (width * 728) / 1920),
      Math.max(0, width - margin * 2)
    ),
    maxHeight: Math.max(0, top + height - margin - minTop)
  };
};

export const placePreview = (anchor, bounds, contentHeight) => {
  const height = Math.min(contentHeight, bounds.maxHeight);
  const centerX = anchor.left + anchor.width / 2;
  const centerY = anchor.top + anchor.height / 2;
  return {
    left: Math.max(
      bounds.left,
      Math.min(centerX - bounds.width / 2, bounds.right - bounds.width)
    ),
    top: Math.max(
      bounds.top,
      Math.min(centerY - height / 2, bounds.bottom - height)
    ),
    height
  };
};
